'use client';

import { CampaignState } from '@/types/campaign';
import { useCallback, useState, useMemo } from 'react';

type UseDiscountBannerProps = {
  campaignInfo: CampaignState | null;
};

export function useDiscountBanner({ campaignInfo }: UseDiscountBannerProps) {
  const campaignExists = Boolean(campaignInfo?.campaignExists);
  const campaignActive = Boolean(campaignInfo?.campaignActive);

  const [showBanner, setShowBanner] = useState(campaignExists);

  const handleClose = useCallback(() => {
    setShowBanner(false);
  }, []);

  const bannerType = useMemo(() => {
    if (!showBanner) return null;
    return campaignActive ? 'success' : 'error';
  }, [showBanner, campaignActive]);

  return {
    showBanner,
    handleClose,
    bannerType,
  };
}
